import { createContext, useContext } from 'react';

// True when assistant responses are rendered inside the Chrome extension
// panel — a narrow, embedded, self-contained surface. Renderers use this to
// stay minimal (Slack-like): tables become stacked cards, and entity
// references render as plain non-interactive badges instead of links, so
// nothing navigates the user out of the extension.
const ExtensionSurfaceContext = createContext(false);

export const ExtensionSurfaceProvider = ExtensionSurfaceContext.Provider;

export function useIsExtensionSurface(): boolean {
    return useContext(ExtensionSurfaceContext);
}
